import React, { useEffect, useState } from 'react'

import { number, bool, func, object } from 'prop-types'

import CleanModal from '../../../components/shared/modals/CleanModal'
import FormGestor from './FormGestor'

const ModalGestor = ({ onClose, open, data, id_gestor }) => {
  const [status, setStatus] = useState(false)

  useEffect(() => {
    setStatus(open)
  }, [open])

  useEffect(() => {
    onClose(status)
  }, [status])

  return (
    <CleanModal
      title="Editar Gestor"
      sx={{ width: { xs: '100vw', md: '30vw' } }}
      status={status}
      onClose={() => onClose(false)}
    >
      <>
        <FormGestor
          submitMethod="put"
          onSubmitEnd={() => {
            onClose(false)
          }}
          data={data}
          id={id_gestor}
        />
      </>
    </CleanModal>
  )
}
ModalGestor.propTypes = {
  open: bool,
  data: object,
  id_gestor: number,
  onClose: func
}
export default ModalGestor
